<header id="page-topbar" data-scroll-header>
    <div class="layout-width">
        <div class="navbar-header">
            <div class="d-flex">
                <div class="navbar-brand-box horizontal-logo">
                    <a href="javascript:void(0);" class="logo logo-dark">
                        <span class="logo-sm">
                            <img src="assets/images/logo-small.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/expand-Logo-white.png" alt="" height="17">
                        </span>
                    </a>

                    <a href="javascript:void(0);" class="logo logo-light">
                        <span class="logo-sm w-100">
                            <img src="assets/images/logo-small.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/expand-Logo-white.png" alt="" height="17">
                        </span>
                    </a>
                </div>


            </div>

            <div class="d-flex align-items-center">
                <div class="d-flex align-items-center">
                    <div ngbDropdown class="dropdown topbar-head-dropdown  header-item ">
                        <button type="button" ngbDropdownToggle
                            class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                            id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <i class="Bell"></i>
                            @if(this.notificationCount >= 1){
                            <span
                                class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
                                {{ this.notificationCount }}
                                <span class="visually-hidden">unread messages</span></span>
                            }
                        </button>
                        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                            aria-labelledby="page-header-notifications-dropdown">
                            <div class="dropdown-head bg-pattern rounded-top">
                                <div class="p-3">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <h6 class="m-0 fs-16 fw-semibold text-black">Notifications</h6>
                                        </div>
                                        <div class="col-auto dropdown-tabs">
                                            <span class="badge bg-light-subtle text-body fs-13">
                                                {{ notificationList?.length }} New</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="px-2 pt-2">
                                    <kendo-tabstrip class="mb-4">
                                        <kendo-tabstrip-tab title="All" [selected]="true">

                                            <ng-template kendoTabContent>
                                                <div class="tab-pane fade show active py-2 ps-2" id="all-noti-tab"
                                                    role="tabpanel">
                                                    <ngx-simplebar style="max-height: 300px">
                                                        <div class="pe-2">
                                                            @for(item of notificationList;track $index){
                                                            <div
                                                                class="text-reset notification-item d-block dropdown-item position-relative">
                                                                <div class="d-flex">

                                                                    <div class="flex-grow-1">
                                                                        <a href="javascript:void(0);"
                                                                            class="stretched-link"
                                                                            >
                                                                            <h6 class="mt-0 mb-2 lh-base">{{
                                                                                item.message }}</h6>
                                                                        </a>
                                                                    </div>
                                                                    <!-- } -->
                                                                </div>
                                                            </div>
                                                            } @empty{
                                                            <div class="tab-pane p-4" id="alerts-tab" role="tabpanel"
                                                                aria-labelledby="alerts-tab">
                                                                <div class="text-center pb-5 mt-2">
                                                                    <h6 class="fs-18 fw-semibold lh-base">
                                                                        Hey! You have no any notifications
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                            }
                                                            <!-- <div class="my-3 d-flex justify-content-center">
                                                                <button type="button" (click)="allNotifications()"
                                                                    class="btn btn-primary">
                                                                    View All Notifications
                                                                    <i class="ArrowRight"></i>
                                                                </button>
                                                            </div> -->
                                                        </div>
                                                    </ngx-simplebar>
                                                </div>
                                            </ng-template>
                                        </kendo-tabstrip-tab>
                                    </kendo-tabstrip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex align-items-center">
                    <div class="line ms-2"></div>
                    <!-- <div class="ms-2 poistion-relative icon-div" [ngClass]="{'bg-popup':isPopup}"
                        (click)="checkOpen(anchor)" (keydown.enter)="checkOpen(anchor)">
                        <i class="DotNine dot-icon" kendoPopoverAnchor [popover]="popover" #anchor="kendoPopoverAnchor"
                            showOn="none"></i>
                    </div> -->
                    <div class="dropdown header-item topbar-user" ngbDropdown>
                        <button type="button" class="btn d-flex align-items-center " id="page-header-user-dropdown"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle
                            (click)="dropdownClick()">
                            <span class="d-flex align-items-center">
                                <img class="rounded-circle header-profile-user" [src]="imageSrc" alt="Header Avatar">
                                <span class="text-start ms-xl-2">
                                    <span
                                        class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{{currentUserDetails?.name
                                        + ' ' + currentUserDetails?.surname}}
                                    </span>
                                </span>
                                <i class="ms-2 {{isDropdown ? 'CaretUp' : 'CaretDown' }}"></i>
                            </span>
                        </button>
                        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                            <!-- item-->
                            <h6 class="dropdown-header">Welcome {{currentUserDetails?.name + ' ' +
                                currentUserDetails?.surname}}!</h6>
                            <a class="dropdown-item pe-auto" (click)="navigate()"><i
                                    class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> <span
                                    class="align-middle">Profile</span></a>
                            <a class="dropdown-item" routerLink="/apps/chat"><i
                                    class="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span
                                    class="align-middle">Messages</span></a>
                            <a class="dropdown-item d-flex" (click)="tour()"><i
                                    class="Play  text-muted fs-16 align-middle me-1"></i>
                                <span class="align-middle">Start Tour</span></a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="javascript: void(0);" (click)="logout()"><i
                                    class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    class="align-middle" data-key="t-logout">Logout</span></a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</header>

<!-- removeNotificationModal -->
<ng-template #removenotification let-modal>
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                id="NotificationModalbtn-close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="mt-2 text-center">
                <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                    <h4>Are you sure ?</h4>
                    <p class="text-muted mx-4 mb-0">Are you sure you want to remove this Notification ?</p>
                </div>
            </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal"
                    (click)="modal.dismiss('Cross click')">Close</button>
                <button type="button" class="btn w-sm btn-danger" id="delete-notification"
                    (click)="notificationDelete()">Yes, Delete It!</button>
            </div>
        </div>

    </div><!-- /.modal-content -->

</ng-template>

<kendo-popover #popover position="bottom" [callout]="false">
    <ng-template kendoPopoverBodyTemplate let-anchor let-data="data">
        <div class="row m-0 w-300">
            <div class="col-12 p-0">
                <p class="app-header">Your Nextere Apps</p>
            </div>
        </div>
        <div class="row m-0 w-300">
            <div class="col-4">
                <a class="text-dark text-decoration-none  d-flex justify-content-center align-items-center flex-column"
                    href="{{ environmentURL.onboardingURL }}" target="_blank">
                    <img class="size" src="../../../assets/images/01_Core.png" alt="central" />
                    <p class="app-text mt-1">Central</p>
                </a>
            </div>
            <div class="col-4">
                <a class="text-dark text-decoration-none d-flex justify-content-center align-items-center flex-column"
                    href="{{ environmentURL.commissionURL }}" target="_blank">
                    <img class="size" src="../../../assets/images/Commission.png" alt="commission" />
                    <p class="app-text mt-1">Pay</p>
                </a>
            </div>
            <div class="col-4">
                <a class="text-dark text-decoration-none  d-flex justify-content-center align-items-center flex-column"
                    href="{{ environmentURL.signURL }}" target="_blank">
                    <img class="size" src="../../../assets/images/Sign.png" alt="sign" />
                    <p class="app-text mt-1 sign">Sign</p>
                </a>
            </div>
            <div class="col-4">
                <a class="text-dark text-decoration-none d-flex justify-content-center align-items-center flex-column"
                    href="{{ environmentURL.conXentURL }}" target="_blank">
                    <img class="size" src="../../../assets/images/Consent.png" alt="conxent" />
                    <p class="app-text mt-1">Consent</p>
                </a>
            </div>
            <div class="col-4">
                <a class="text-dark text-decoration-none  d-flex justify-content-center align-items-center flex-column"
                    href="{{ environmentURL.phoneURL }}" target="_blank">
                    <img class="size" src="../../../assets/images/Phone.png" alt="Phone" />
                    <p class="app-text mt-1 mb-0">Phone</p>
                </a>
            </div>
            <div class="col-4">
                <a class="text-dark text-decoration-none  d-flex justify-content-center align-items-center flex-column"
                    href="{{ environmentURL.smsURL }}" target="_blank">
                    <img class="size" src="../../../assets/images/SMS.png" alt="sign" />
                    <p class="app-text mt-1 sign">SMS</p>
                </a>
            </div>
        </div>
    </ng-template>
</kendo-popover>